import { render, staticRenderFns } from "./addTablesAndWaiters.vue?vue&type=template&id=6d1d64f1&scoped=true"
import script from "./addTablesAndWaiters.vue?vue&type=script&lang=js"
export * from "./addTablesAndWaiters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d64f1",
  null
  
)

export default component.exports